// Twilio reports a number either as plain E.164 ("+17142806879") or wrapped in a Client identity
// string ("client:+14155620988-<userId>-<deviceId>"). Pull the leading E.164 number out so it can
// be formatted; fall back to the original value when no number is present.
export const normalizeTwilioPhone = (value: string): string => value.match(/\+\d+/)?.[0] ?? value;
